import { useI18nContext } from '@/i18n/i18n-react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import {
  ANALYTICS_TABS,
  parseAnalyticsTab,
  type AnalyticsTab,
} from '@/lib/analytics-tabs';

export interface AnalyticsTabsBarProps {
  tab: AnalyticsTab;
  /** `overview` clears `?tab=` (see `useAnalyticsTab`). */
  onTabChange: (tab: AnalyticsTab) => void;
}

/**
 * ANLT-01: Resumo · Vendas · Push · Usuários · Pedidos, one tab at a time,
 * on the desktop and on the phone.
 */
export function AnalyticsTabsBar({ tab, onTabChange }: AnalyticsTabsBarProps) {
  const { LL } = useI18nContext();
  const labels: Record<AnalyticsTab, string> = {
    overview: LL.metricsPage.tabs.overview(),
    sales: LL.metricsPage.tabs.sales(),
    campaigns: LL.metricsPage.tabs.campaigns(),
    users: LL.metricsPage.tabs.users(),
    orders: LL.metricsPage.tabs.orders(),
  };

  return (
    <Tabs
      value={tab}
      onValueChange={(value) => onTabChange(parseAnalyticsTab(value))}
    >
      <TabsList
        aria-label={LL.metricsPage.tabs.label()}
        className="max-w-full overflow-x-auto"
      >
        {ANALYTICS_TABS.map((value) => (
          <TabsTrigger key={value} value={value}>
            {labels[value]}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
